import { addToast } from "components/ToastContainer/ToastStore";
import { routeConstants } from "constants/routeConstants";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForgotPasswordMutation } from "slice/userAuth";
import { validations } from "utils/validations";

export const useForgotPassword = () => {
    const navigateTo = useNavigate();
    const [forgotPassword, { isLoading, isSuccess, isError }] =
        useForgotPasswordMutation();

    const [email, setEmail] = useState(""),
        [emailError, setEmailError] = useState("");

    const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value);
        setEmailError(validations("email", e.target.value));
    };

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const emailError = validations("email", email);
        setEmailError(emailError);
        if (email !== "" && emailError === "") {
            forgotPassword(email);
        }
    };

    useEffect(() => {
        if (isSuccess) {
            navigateTo(routeConstants.login, {
                state: {
                    toast: true,
                    data: {
                        type: "success",
                        text: "Success! If your email is valid, you should receive a reset password email.",
                    },
                },
            });
        }
    }, [isSuccess, navigateTo]);

    useEffect(() => {
        if (isError) {
            addToast({
                type: "error",
                text: "Something went wrong, please try again.",
            });
        }
    }, [isError]);

    return {
        email,
        emailError,
        handleEmailChange,
        handleSubmit,
        isLoading,
    };
};
